import React from 'react';
import './Sections.scss';
import Hyperlink from '../Hyperlink/Hyperlink';

function Section5() {
  const hyperlinkData = [
    {
      href: 'https://www.rd.usda.gov/programs-services/single-family-housing-programs',
      copy: 'USDA’s Rural Development program',
      label: 'Visit Highlights From the Profile of Home Buyers and Sellers'
    },
    {
      href: 'https://www.hud.gov/buying/loans',
      copy: 'FHA loan',
      label: 'Visit Highlights From the Profile of Home Buyers and Sellers'
    },
    {
      href: 'https://www.ncsha.org/housing-help/',
      copy: 'individual states have programs and incentives',
      label: 'Visit Highlights From the Profile of Home Buyers and Sellers'
    }
  ];
  return (
    <section className="sections sections-section5">
      <h2 className="sections-title">Mortgage Assistance Programs</h2>
      <p className="sections-copy">
        Moving outside of urban centers has advantages beyond more affordable housing. Buyers may be
        able to take advantage of a mortgage from the <Hyperlink hyperlinkData={hyperlinkData[0]} />
        , which allows select buyers to purchase a home with no money down. A year ago, buyers using
        federal- or state-backed mortgage products might have had difficulty competing in the
        red-hot marketplace, where they would lose out to repeat buyers coming in with more equity
        or all-cash bids. As Lautz points out, it might actually be an ideal time for buyers using
        loan programs to look for property because there’s slightly less competition.
      </p>
      <p className="sections-copy">
        First time buyers might be able to avail themselves of a{' '}
        <Hyperlink hyperlinkData={hyperlinkData[1]} />, a mortgage backed by the federal government
        that has lower minimum down payments than traditional mortgage products. On a local level,{' '}
        <Hyperlink hyperlinkData={hyperlinkData[2]} /> that can help first-time buyers get a
        mortgage. “Those programs are largely underutilized and do fly under the radar,” Lautz
        remarks. “ A lot of local communities even have options.” Of course, most buyers—whether
        first-time or repeat—aren’t experts at wading through government mortgage programs. The good
        news is that they don’t need to be. The trick, Lautz says, is partnering with "a good
        mortgage broker who will be able to find you low down payment programs.”
      </p>

      <div className="quote">
        <div className="quote__contents">
          <div className="quotationMark">“</div>
          <blockquote className="quote__copy">
            Hold onto that dream of home ownership because, if you work with those experts, they’ll
            try and help you get there—perhaps sooner than you imagined you could.”
          </blockquote>
          <div className="quote__caption">
            Dr. Jessica Lautz,{' '}
            <span className="italic">
              Deputy Chief Economist and Vice President of Research at NAR
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Section5;
